export default "__VITE_ASSET__651cad6e__"